import { Component, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { GoogleChartComponent, GoogleChartInterface } from 'ng2-google-charts';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-geo-chart',
  templateUrl: './geo-chart.component.html',
  styleUrl: './geo-chart.component.scss',
})
export class GeoChartComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('chart') chart: GoogleChartComponent;

  @Input() data: Observable<any>;

  tableData: any[][];

  constructor(
    private viewportRuler: ViewportRuler,
    private ngZone: NgZone,
  ) {
    super();
  }

  ngOnInit() {
    this.getData();
    this.onResize();
  }

  ngOnDestroy() {
    this.viewportRuler.ngOnDestroy();
  }

  get geoChart(): GoogleChartInterface {
    const { width, height } = this.viewportRuler.getViewportSize();
    return {
      chartType: 'GeoChart',
      dataTable: this.tableData,
      options: {
        colorAxis: { colors: ['yellow', 'red'] },
        width: width - (width > 1400 ? 304 : 64),
        height: height - 197,
      },
    };
  }

  private getData() {
    if (this.data) {
      this.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
        if (data?.length > 1) {
          this.tableData = data;
          this.redraw();
        }
      });
    }
  }

  private onResize() {
    this.viewportRuler
      .change()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.ngZone.run(() => this.redraw()));
  }

  private redraw() {
    this.chart?.draw(this.geoChart);
  }
}
